import { render, staticRenderFns } from "./StaticString.vue?vue&type=template&id=489c8678"
import script from "./StaticString.vue?vue&type=script&lang=js"
export * from "./StaticString.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports